export class DegradeError extends Error {
	public isDegraded: boolean = true;
}
